module.exports = __webpack_public_path__ + "img/home.80fa99ec.svg";